import { render, staticRenderFns } from "./WeiboUser.vue?vue&type=template&id=04408a72&scoped=true&"
import script from "./WeiboUser.vue?vue&type=script&lang=js&"
export * from "./WeiboUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04408a72",
  null
  
)

export default component.exports